import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FormGroup } from 'reactstrap';
import { H5, P, UL } from '../../../AbstractElements';
import SocialAuth from './SocialAuth';

const SignInWith = ({ t }) => {
    return (
        <Fragment>
            {/*<div className='login-social-title'><H5>Sign in with</H5> </div>
            <FormGroup>
                <UL attrUL={{ className: 'simple-list login-social flex-row' }}>
                    <SocialAuth />
                </UL>
            </FormGroup>
            <P>{t("Don't have account ?")}
                <a className='ms-2' href='https://nada-user.suneel.tech/register' target='_blank' rel='noopener noreferrer'>
                    {t("Create Account")}
                </a>
            </P>*/}
        </Fragment>
    );
};
export default SignInWith;
